import Image from 'next/image';
import Link from 'next/link';

import { Button, Heading, Paragraph } from '@swordhealth/ui-corporate';
import { MarkdownRichText } from '@/app/_components/shared';
import { ACTIONS, BUTTON_TYPES, trackButtonClicked } from '@/utils/track';
import {
  BulletPanelList,
  ButtonsWrapper,
  ContactCard,
  ContentWrapper,
  ImageWrapper,
  StyledBullet,
  StyledContainer,
  StyledParagraph,
  Wrapper,
} from './styles';

const ContactPanel = ({ content }) => {
  const {
    image,
    title,
    subtitle,
    buttonPrimary,
    buttonSecondary,
    phoneLinkNumber,
    cardFooterSubtitle,
    emailLink,
    bulletPanelTitle,
    bulletWithIcon,
    config,
  } = content;

  return (
    <StyledContainer xAlign="center">
      <ContactCard $colored={config?.colored === false}>
        <ImageWrapper>
          <Image
            src={image?.data?.attributes.url}
            alt={image?.data?.attributes.alternativeText}
            fill
            objectFit="cover"
            id={'contact-card-image'}
          />
        </ImageWrapper>
        <ContentWrapper>
          <Wrapper>
            <Heading size="xl" weight="bold">
              {title}
            </Heading>
            <StyledParagraph size="sm">{subtitle}</StyledParagraph>
          </Wrapper>
          <ButtonsWrapper>
            <Button
              href={`tel:${buttonPrimary?.href.replace(/\s/g, '')}`}
              size="sm"
              variant="primary"
              target={buttonPrimary?.target}
              onClick={() =>
                trackButtonClicked({
                  action: ACTIONS.PLACE_A_CALL,
                  buttonType: BUTTON_TYPES.NAVIGATION,
                  buttonText: buttonPrimary?.label,
                  destination: buttonPrimary?.href,
                  buttonLocation: 'contact-panel-section',
                })
              }
            >
              {buttonPrimary?.label}
            </Button>
            <Button
              href={`mailto:${buttonSecondary?.href}`}
              size="sm"
              variant="secondary"
              target={buttonSecondary?.target}
              onClick={() =>
                trackButtonClicked({
                  action: ACTIONS.OPEN_EMAIL,
                  buttonType: BUTTON_TYPES.NAVIGATION,
                  buttonText: buttonSecondary?.label,
                  destination: buttonSecondary?.href,
                  buttonLocation: 'contact-panel-section',
                })
              }
            >
              {buttonSecondary?.label}
            </Button>
          </ButtonsWrapper>
          <Wrapper hasDivider>
            <Heading size="xl" weight="bold">
              <Link
                href={`tel:${phoneLinkNumber?.href.replace(/\s/g, '')}`}
                onClick={() =>
                  trackButtonClicked({
                    action: ACTIONS.PLACE_A_CALL_LINK,
                    buttonType: BUTTON_TYPES.NAVIGATION,
                    buttonText: phoneLinkNumber?.label,
                    destination: phoneLinkNumber?.href,
                    buttonLocation: 'contact-panel-section',
                  })
                }
              >
                {phoneLinkNumber?.label}
              </Link>
            </Heading>
            <StyledParagraph size="xs">{cardFooterSubtitle}</StyledParagraph>
            <Paragraph size="sm">
              <Link
                href={`mailto:${emailLink?.href}`}
                onClick={() =>
                  trackButtonClicked({
                    action: ACTIONS.OPEN_EMAIL_LINK,
                    buttonType: BUTTON_TYPES.NAVIGATION,
                    buttonText: emailLink?.label,
                    destination: emailLink?.href,
                    buttonLocation: 'contact-panel-section',
                  })
                }
              >
                {emailLink?.label}
              </Link>
            </Paragraph>
          </Wrapper>
        </ContentWrapper>
      </ContactCard>
      <BulletPanelList>
        <Heading size="2xl" weight="bold">
          {bulletPanelTitle}
        </Heading>
        <div>
          {bulletWithIcon?.map((bullet, index) => (
            <StyledBullet
              key={`bulletItem-${index}`}
              background={false}
              description={
                <MarkdownRichText elements={['b', 'strong', 'i']} key={`bulletText-${index}`}>
                  {bullet?.text}
                </MarkdownRichText>
              }
              icon={bullet?.icon ?? 'circle-check-through-1px'}
              variant="iconLeft"
            />
          ))}
        </div>
      </BulletPanelList>
    </StyledContainer>
  );
};

ContactPanel.defaultConfig = {
  rounded: false,
  colored: true,
  spaceBottom: true,
  spaceTop: false,
  marginBottom: false,
  withGradient: false,
  roundedTop: false,
};

export default ContactPanel;
